import api from './api';

export default {
  getComments(id) {
    return new Promise((resolve, reject) => {
      const params = {
        paginate: 500,
        search: id
      };

      api
        .get('comment/search', { params })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  }
};
